exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-flipbook-index-js": () => import("./../../../src/templates/Flipbook/index.js" /* webpackChunkName: "component---src-templates-flipbook-index-js" */)
}

